import { render, staticRenderFns } from "./electricBagList.vue?vue&type=template&id=1b7e54db&scoped=true&"
import script from "./electricBagList.vue?vue&type=script&lang=js&"
export * from "./electricBagList.vue?vue&type=script&lang=js&"
import style0 from "./electricBagList.vue?vue&type=style&index=0&id=1b7e54db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7e54db",
  null
  
)

export default component.exports